import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dDay from "../Data.Day/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
const RestaurantLocalDay = x => x;
const newtypeRestaurantLocalDay = {Coercible0: () => {}};
const eqRestaurantLocalDay = {eq: x => y => Data$dDate.eqDate.eq(x)(y)};
const ordRestaurantLocalDay = {compare: x => y => Data$dDate.ordDate.compare(x)(y), Eq0: () => eqRestaurantLocalDay};
const asDateRestaurantLocalDay = Restaumatic$dForm$dWidgets.asDateDay;
const genericRestaurantLocalDay = {to: x => x, from: x => x};
const showRestaurantLocalDay = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dDate.showDate.show(v)]})({reflectSymbol: () => "RestaurantLocalDay"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeRestaurantLocalDay = {unsafeDecode: x => Data$dDay.udecodeDay.unsafeDecode(x)};
const encodeRestaurantLocalDay = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericRestaurantLocalDay)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "RestaurantLocalDay"
  })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", DateUtils.formatISODate(v)), Data$dList$dTypes.Nil)}))
};
const decodeRestaurantLocalDay = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericRestaurantLocalDay)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "RestaurantLocalDay"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dDay.decodeDay.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  RestaurantLocalDay,
  asDateRestaurantLocalDay,
  decodeRestaurantLocalDay,
  encodeRestaurantLocalDay,
  eqRestaurantLocalDay,
  genericRestaurantLocalDay,
  newtypeRestaurantLocalDay,
  ordRestaurantLocalDay,
  showRestaurantLocalDay,
  unscrambleDecodeRestaurantLocalDay
};
